import { BASE_THEME as baseTheme } from 'theme/shop_theme';

const defaultLineStyles = {
  line: {
    display: 'block',
    position: 'absolute',
    background: baseTheme.color.gray['90'],
    width: '13px',
    height: '0px',
    left: '50%',
    top: '50%',
    border: `1px solid ${baseTheme.color.gray['90']}`,
    borderRadius: '1px',
    transform: 'translate(-50%,-50%)',
  },
  lineVert: {
    width: '0px',
    height: '13px',
  },
};

export { defaultLineStyles };
